import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import axios from 'axios';

function LayoutWithHeader() {
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      // Optionally, verify the token by sending it to the server
      // axios.get('https://api.pathvizor.com/verify-token', { headers: { Authorization: `Bearer ${token}` } })
      axios.get('https://api.pathvizor.com/verify-token', { headers: { Authorization: `Bearer ${token}` } })
        .then(() => {
        })
        .catch(() => {
          // If token is invalid, clear it from local storage
          localStorage.removeItem('token');
          window.location.href = '/login';
        });
    }
    else {
      window.location.href = '/login';
    }
  }, []);

  return (
    <>
      <Header />
      <Outlet />
    </>
  );
}

export default LayoutWithHeader;
